import './ExpertInfoMini.scss';
import { useGetExpertData } from '../../utils';

const ExpertInfoMini = () => {
  const { expertInfo, expertAvatar } = useGetExpertData();

  const renderValue = (val: any) => {
    if (val && typeof val === 'object') {
      return val.name || JSON.stringify(val);
    }
    return val;
  };

  const name = renderValue(expertInfo?.userName);
  const profession = renderValue(expertInfo?.profession);

  const initials = (name || '?')
    .toString()
    .trim()
    .split(' ')
    .map((part: string) => part[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

  return (
    <div className='expertMiniInfo'>
      <div className='avatarWrap'>
        {expertAvatar ? (
          <img src={`data:image/png;base64,${expertAvatar}`} alt='expert-avatar' className='avatar' />
        ) : (
          <span className='avatarInitials'>{initials}</span>
        )}
      </div>
      <div className='expertDescr'>
        <p className='title'>{name}</p>
        {profession && <p className='profession'>{profession}</p>}
      </div>
    </div>
  );
};

export default ExpertInfoMini;